/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menu_Quit_Current_Run_TitleInputs */

const bn_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বর্তমান রান প্রস্থান করবেন?`)
};

const de_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuellen Lauf beenden?`)
};

const el_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έξοδος από την τρέχουσα εκτέλεση;`)
};

const en_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quit current run?`)
};

const es_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Salir de la ejecución actual?`)
};

const fr_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitter la partie en cours ?`)
};

const hi_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान रन छोड़ें?`)
};

const hu_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilép a jelenlegi futtatásból?`)
};

const id_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti menjalankan saat ini?`)
};

const it_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uscire dalla corsa corrente?`)
};

const ja_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の実行を終了しますか?`)
};

const ko_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 실행을 종료하시겠습니까?`)
};

const nl_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huidige run beëindigen?`)
};

const pl_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakończyć bieżący bieg?`)
};

const pt_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair da execução atual?`)
};

const ru_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выйти из текущего запуска?`)
};

const sv_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avsluta nuvarande körning?`)
};

const tr_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevcut çalıştırmadan çıkılsın mı?`)
};

const uk_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вийти з поточного запуску?`)
};

const vi_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thoát khỏi hoạt động hiện tại?`)
};

const zh_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出当前运行？`)
};

const zh_hant_menu_quit_current_run_title = /** @type {(inputs: Menu_Quit_Current_Run_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出當前運行？`)
};

/**
* | output |
* | --- |
* | "Quit current run?" |
*
* @param {Menu_Quit_Current_Run_TitleInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const menu_quit_current_run_title = /** @type {((inputs?: Menu_Quit_Current_Run_TitleInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menu_Quit_Current_Run_TitleInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_menu_quit_current_run_title(inputs)
	if (locale === "de") return de_menu_quit_current_run_title(inputs)
	if (locale === "el") return el_menu_quit_current_run_title(inputs)
	if (locale === "en") return en_menu_quit_current_run_title(inputs)
	if (locale === "es") return es_menu_quit_current_run_title(inputs)
	if (locale === "fr") return fr_menu_quit_current_run_title(inputs)
	if (locale === "hi") return hi_menu_quit_current_run_title(inputs)
	if (locale === "hu") return hu_menu_quit_current_run_title(inputs)
	if (locale === "id") return id_menu_quit_current_run_title(inputs)
	if (locale === "it") return it_menu_quit_current_run_title(inputs)
	if (locale === "ja") return ja_menu_quit_current_run_title(inputs)
	if (locale === "ko") return ko_menu_quit_current_run_title(inputs)
	if (locale === "nl") return nl_menu_quit_current_run_title(inputs)
	if (locale === "pl") return pl_menu_quit_current_run_title(inputs)
	if (locale === "pt") return pt_menu_quit_current_run_title(inputs)
	if (locale === "ru") return ru_menu_quit_current_run_title(inputs)
	if (locale === "sv") return sv_menu_quit_current_run_title(inputs)
	if (locale === "tr") return tr_menu_quit_current_run_title(inputs)
	if (locale === "uk") return uk_menu_quit_current_run_title(inputs)
	if (locale === "vi") return vi_menu_quit_current_run_title(inputs)
	if (locale === "zh") return zh_menu_quit_current_run_title(inputs)
	return zh_hant_menu_quit_current_run_title(inputs)
});